import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { Person_Amozesh_Interface } from 'src/app/Interface/Person_Amozesh_Interface';
import { Person_Document_Interface } from 'src/app/Interface/Person_Document_Interface';
import { Person_Interface } from 'src/app/Interface/Person_Interface';
import { Person_Kari_Interface } from 'src/app/Interface/Person_Kari_Interface';
import { Person_Skill_Interface } from 'src/app/Interface/Person_Skill_Interface';
import { Person_Tahghigh_Interface } from 'src/app/Interface/Person_Tahghigh_Interface';
import { Person_Tahsili_Interface } from 'src/app/Interface/Person_Tahsili_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PersonService {

  constructor(private http: HttpClient) { }


  GetRecord(listType:number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Persone?listType=" + listType).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetActive(): Observable<Array<Persone_List_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Persone/GetActive").pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetUser(): Observable<Array<Persone_List_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Persone/GetUser").pipe(
      map(data => {
        return data as Array<Persone_List_Interface>
      })
    )
  }

  GetHasUser(): Observable<Array<Persone_List_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Persone/GetHasUser").pipe(
      map(data => {
        return data as Array<Persone_List_Interface>
      })
    )
  }

  GetExpertCalibration(): Observable<Array<Persone_List_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Persone/GetExpertCalibration").pipe(
      map(data => {
        return data as Array<Persone_List_Interface>
      })
    )
  }

  GetSingle(id: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Persone/GetSingle?id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }


  DeletePersone(id: number): Observable<Persone_List_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Persone/Delete?id=" + id ).pipe(
      map(data => {
        return data as Persone_List_Interface
      })
    )

  }

  AddPersone(
    model: Person_Interface,
    person_Kari: Array<Person_Kari_Interface>,
    person_Tahsili: Array<Person_Tahsili_Interface>,
    person_Amozesh: Array<Person_Amozesh_Interface>,
    person_Skill: Array<Person_Skill_Interface>,
    person_Tahghigh: Array<Person_Tahghigh_Interface>,
    person_Document: Array<Person_Document_Interface>
  ): Observable<Person_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body_person_Amozesh = []
    for (let item of person_Amozesh) {
      body_person_Amozesh.push({
        id: item.id,
        person_id: item.person_id,
        date_starrt: item.date_starrt,
        date_end: item.date_end,
        sarFaslAmozeshi_id: item.sarFaslAmozeshi_id,
        dorehAmoozeshi_id: item.dorehAmoozeshi_id,
        modat: item.modat,
        bargozarKonnadeh: item.bargozarKonnadeh,
        image: item.image,
      }
      )
    }

    var body_person_Skill = []
    for (let item of person_Skill) {
      body_person_Skill.push({
        id: item.id,
        person_id: item.person_id,
        skill_id: item.skill_id,
        percennt: item.percennt
      }
      )
    }

    var body_person_Document = []
    for (let item of person_Document) {
      body_person_Document.push({
        id: item.id,
        person_id: item.person_id,
        grpDoc_id: item.grpDoc_id,
        tlDoc_id: item.tlDoc_id,
        shomareh: item.shomareh,
        taminKonandeh: item.taminKonandeh
      }
      )
    }


    var body = {
      Token: '',
      model: model,
      person_Kari: person_Kari,
      person_Tahsili: person_Tahsili,
      person_Amozesh: body_person_Amozesh,
      person_Skill: body_person_Skill,
      person_Tahghigh: person_Tahghigh,
      person_Document: body_person_Document,
    }

    return this.http.post(environment.BaseUrl + "Daro/Persone/Add", body, { headers }).pipe(
      map(data => {
        return data as Person_Interface
      })
    )

  }

  EditPersone(
    model: Person_Interface): Observable<Person_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');



    var body = {
      Token: '',
      model: model,
      person_Kari: null,
      person_Tahsili: null,
      person_Amozesh: null,
      person_Skill: null,
      person_Tahghigh: null,
      person_Document: null,
    }


    return this.http.post(environment.BaseUrl + "Daro/Persone/Edit", body, { headers }).pipe(
      map(data => {
        return data as Person_Interface
      })
    )

  }


  EditPersone1(
    model: Person_Interface,
    person_Kari: Array<Person_Kari_Interface>,
    person_Tahsili: Array<Person_Tahsili_Interface>,
    person_Amozesh: Array<Person_Amozesh_Interface>,
    person_Skill: Array<Person_Skill_Interface>,
    person_Tahghigh: Array<Person_Tahghigh_Interface>,
    person_Document: Array<Person_Document_Interface>): Observable<Person_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body_person_Amozesh = []
    for (let item of person_Amozesh) {
      body_person_Amozesh.push({
        id: item.id,
        person_id: item.person_id,
        date_starrt: item.date_starrt,
        date_end: item.date_end,
        sarFaslAmozeshi_id: item.sarFaslAmozeshi_id,
        dorehAmoozeshi_id: item.dorehAmoozeshi_id,
        modat: item.modat,
        bargozarKonnadeh: item.bargozarKonnadeh,
        image: item.image,
      }
      )
    }

    var body_person_Skill = []
    for (let item of person_Skill) {
      body_person_Skill.push({
        id: item.id,
        person_id: item.person_id,
        skill_id: item.skill_id,
        percennt: item.percennt
      }
      )
    }

    var body_person_Document = []
    for (let item of person_Document) {
      body_person_Document.push({
        id: item.id,
        person_id: item.person_id,
        grpDoc_id: item.grpDoc_id,
        tlDoc_id: item.tlDoc_id,
        shomareh: item.shomareh,
        taminKonandeh: item.taminKonandeh
      }
      )
    }


    var body = {
      Token: '',
      model: model,
      person_Kari: person_Kari,
      person_Tahsili: person_Tahsili,
      person_Amozesh: body_person_Amozesh,
      person_Skill: body_person_Skill,
      person_Tahghigh: person_Tahghigh,
      person_Document: body_person_Document,
    }


    return this.http.post(environment.BaseUrl + "Daro/Persone/Edit1", body, { headers }).pipe(
      map(data => {
        return data as Person_Interface
      })
    )

  }


  uploadFile(body) {

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Persone/Upload", body).pipe(
      map(data => {

        return data
      })
    )
  }


}
